import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=e653451c&scoped=true&"
import script from "./Policy.vue?vue&type=script&lang=js&"
export * from "./Policy.vue?vue&type=script&lang=js&"
import style0 from "./Policy.vue?vue&type=style&index=0&id=e653451c&prod&scoped=true&lang=css&"
import style1 from "./Policy.vue?vue&type=style&index=1&id=e653451c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e653451c",
  null
  
)

export default component.exports